import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Premium <span>Ionic Development Services</span> for Powerful,
              Feature-Rich Applications
            </h2>
            <p>
              At TekRevol, we offer top-of-the-line ionic app development
              services using a vast array of unique components to effectively
              cater to the requirements of cross-platform development. TekRevol
              is one of the leading companies to offer ionic app development
              services and we guarantee you that the customization found in our
              applications will be no match in the market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Hire our Ionic App Developers Today
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Ionic App Consultation</h4>
                  <p>
                    Our experts at TekRevol are here to help you refine your raw
                    ideas and advise you as per the latest trends in Ionic App
                    development. We assure you that your application will have
                    guaranteed cross-platform compatibility with superior user
                    experience while providing adequate support throughout the
                    development journey.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Ionic Widget Development</h4>
                  <p>
                    We create extremely unique widgets for your applications
                    using the powerful Ionic Framework and HTML5. Our developers
                    are highly skilled at making use of agile methodologies and
                    other plugins to deliver smoothly running applications that
                    are cost-effective and also enhance the overall
                    functionality of your app.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Quality Assurance and Testing</h4>
                  <p>
                    There is a dedicated team at TekRevol that looks after the
                    quality of your application and ensures that it is fully
                    optimized in terms of its performance. There is a manual as
                    well as an automated quality control process where we make
                    use of tools like Ionic CLI for unit testing and other ionic
                    components for superior performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Ionic App Development</h4>
                  <p>
                    TekRevol assures to deliver custom-tailored ionic app
                    development for you through adapting best practices of
                    hybrid cross-platform development. We make sure that the
                    apps are scalable and secure with a front end comprising
                    open-source UI tool kit components and equally efficient
                    back-end integration.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Ionic App Migration</h4>
                  <p>
                    At TekRevol, we offer seamless migration of services, from
                    the older version to the latest version of the Ionic App in
                    a way that the performance gives you smooth performance
                    through scalability and enhanced responsiveness. The process
                    is extremely cost-effective while maintaining the user
                    experience and offering staunch security of the app.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>App Support and Maintenance</h4>
                  <p>
                    We offer you support and maintenance services throughout to
                    ensure that your Ionic app gives optimum performance. We
                    manage your real-time data, give regular updates, and aim to
                    maintain the functionality of the ionic app produced.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
